module.exports = __webpack_public_path__ + "static/media/保腎4.1d9cd042.png";